import React, { Component } from 'react'
import { FaInstagram, FaMailBulk, FaLinkedinIn, FaTwitter, FaGithub} from "react-icons/fa"
import configs from '../../../configs.json'

class Team extends Component {
    constructor(props) {
        super(props)
        this.state = {
            colored   : this.props.colored,
            dark      : this.props.dark
        }
    }
    colorize() {
        if (this.state.colored && this.state.dark) {
            this.setState({backgroundColor : configs.colors.primary})
            this.setState({text            : configs.colors.light})
            this.setState({color           : configs.colors.dark})
        }
        if (!this.state.colored && !this.state.dark) {
            this.setState({color           : configs.colors.primary})
            this.setState({text            : configs.colors.dark})
            this.setState({backgroundColor : configs.colors.light})
        }
        if (!this.state.colored && this.state.dark) {
            this.setState({color           : configs.colors.primary})
            this.setState({text            : configs.colors.light})
            this.setState({backgroundColor : configs.colors.dark})
        }
        if (this.state.colored && !this.state.dark) {
            this.setState({backgroundColor : configs.colors.primary})
            this.setState({text            : configs.colors.dark})
            this.setState({color           : configs.colors.light})
        }
    }
    componentDidMount() {
        this.colorize()
    }
    render(){
        return (
            <div className='container' style={{backgroundColor: this.state.backgroundColor }} id='team'>
                <div className='row section-row'>
                    <h3 style={{color: this.state.color}}>Time</h3>
                    <h6 style={{color: this.state.text}}>Conheça nosso time</h6>
                    <br></br>
                    {configs.team.map((t) =>
                        <div className='col s12 m4' key={t.name}>
                            <div className='card-panel' style={{backgroundColor: configs.colors.offwhite, minWidth: 'max-content', maxHeight: '50vh'}}>
                                <img style={{border:'4px solid'+configs.colors.primary, width: '40vw', maxWidth: '200px'}} src={require("../../../static/imgs/profile.jpeg")} alt="" className="circle responsive-img team-img"/>
                                <h5>{t.name}</h5>
                                <h6 style={{color:configs.colors.secondary}}>{t.job}</h6>
                                <p>{t.description}</p>
                                <a href='https://www.instagram.com/lucamoreira_of/'><FaInstagram  className='social-icon hoverable' style={{color:configs.colors.secondary}} /></a>
                                <a href='mailto:lucamoreiraofficial@gmail.com'>      <FaMailBulk   className='social-icon hoverable' style={{color:configs.colors.secondary}} /></a>
                                <a href='https://www.linkedin.com/in/luca-moreira/'><FaLinkedinIn className='social-icon hoverable' style={{color:configs.colors.secondary}} /></a>
                                <a href='https://github.com/LucaMoreira'>           <FaGithub     className='social-icon hoverable' style={{color:configs.colors.secondary}}/></a>
                                <a href='https://twitter.com/lucamoreiraofc'>       <FaTwitter    className='social-icon hoverable' style={{color:configs.colors.secondary}} /></a>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        )
    }
}

export default Team